var render = function render(_c,_vm){return _c('div',{staticClass:"card-section",attrs:{"data-test":"card-section"}},[_c('h2',{staticClass:"card-section__header",attrs:{"data-test":"card-section-header"}},[_vm._t("heading")],2),_vm._v(" "),_c('div',{staticClass:"card-section__content",attrs:{"data-test":"card-section-content"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }